import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

type ImageScale = 'Small' | 'Large';
type ContentAlignment = 'center' | 'left' | 'bottom';

export const Wrapper = styled.div<{
  $contentAlignment: ContentAlignment;
  $imageScale: ImageScale;
}>`
  position: relative;
  width: 100%;
  min-height: ${props => (props.$imageScale === 'Small' ? '400px' : '600px')};
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  ${baseVariables.mediaQuery.tablet} {
    min-height: ${props => (props.$imageScale === 'Small' ? '500px' : '700px')};
  }

  ${baseVariables.mediaQuery.desktop} {
    min-height: ${props => (props.$imageScale === 'Small' ? '600px' : '800px')};
  }
`;

export const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const ScrimContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
`;

export const ContentContainer = styled.div<{ $contentAlignment: string }>`
  position: relative;
  z-index: 3;
  width: 100%;
  padding: 2rem 1rem;
  display: flex;
  justify-content: ${props => {
    if (props.$contentAlignment === 'center') return 'center';
    if (props.$contentAlignment === 'left') return 'flex-start';
    return 'center';
  }};
  align-items: ${props => (props.$contentAlignment === 'center' ? 'center' : 'flex-end')};

  ${baseVariables.mediaQuery.tablet} {
    padding: 3rem 2rem;
  }

  ${baseVariables.mediaQuery.desktop} {
    padding: 4rem 3rem;
    max-width: 1200px;
    margin: 0 auto;
  }
`;

export const ContentInner = styled.div<{ $contentAlignment: string }>`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: ${props => (props.$contentAlignment === 'center' ? '800px' : '600px')};
  width: 100%;
  align-items: ${props => {
    if (props.$contentAlignment === 'center') return 'center';
    return 'flex-start';
  }};

  ${baseVariables.mediaQuery.tablet} {
    gap: 2rem;
  }

  ${baseVariables.mediaQuery.desktop} {
    gap: 2.5rem;
  }
`;

export const BrandElementWrapper = styled.div<{ $contentAlignment: string }>`
  display: flex;
  justify-content: ${props => (props.$contentAlignment === 'center' ? 'center' : 'flex-start')};
  width: 100%;
`;

export const TextBlockWrapper = styled.div<{ $contentAlignment: string }>`
  width: 100%;
  text-align: ${props => (props.$contentAlignment === 'center' ? 'center' : 'left')};
`;

export const ButtonGroup = styled.div<{ $contentAlignment: string }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  align-items: ${props => (props.$contentAlignment === 'center' ? 'center' : 'flex-start')};

  ${baseVariables.mediaQuery.tablet} {
    flex-direction: row;
    gap: 1.5rem;
  }
`;

export const OverlayButtonWrapper = styled.div`
  display: inline-flex;
`;
